import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    border: `solid 1px gainsboro`,
    borderRadius: '5px',
    background: 'white',
    cursor: 'pointer',

    '&:not(:last-child)': {
      marginBottom: '0.5rem'
    }
  },

  title: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    padding: '0.7rem',
    paddingRight: '0',
    fontSize: theme.size.sm
  },

  controls: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'stretch',
    paddingLeft: '0.5rem',
    paddingRight: '0.5rem',
    cursor: 'default',

    '& > *': {
      cursor: 'pointer'
    }
  },

  drag: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '0.125rem'
  },

  icon: {
    marginRight: '0.5rem'
  }
}))

export default useStyles
